import React from 'react';
import { EmployerResourcesIcon, KeyboardReturnIcon, ManageAccountIcon, PersonIcon, } from '@digitools/honest-ui/icons';
import { Experience } from 'src/types/Experience';
import { Language } from 'src/types/Language';
// Mirrors the role-counting and gating in src/components/header/ExperienceMenu.tsx.
// Items use `as: 'link'` — the library now fires onClick alongside react-router
// navigation, so side effects (setExperience / setIsNewNav / changeLanguage) run
// on click while the Link handles routing.
//
// Returns `undefined` when the experience menu should be hidden entirely:
//   - no `customerInContext` (e.g. the /customer-search page before selection), or
//   - the user only has a single experience role — nothing to switch to.
// Header keys the whole secondary-menu prop bundle off this being defined.
const buildExperienceMenuItems = ({ user, customEmployeeText, adminHomeUrl, setExperience, setIsNewNav, changeLanguage, trackPageEvent, }) => {
    if (!user.customerInContext)
        return undefined;
    let roles = 0;
    let isEmployee = false;
    let isEmployer = false;
    let isInternal = false;
    let isMultiCustomer = false;
    let showNewNavMenu = false;
    if (user.roles.indexOf('employee') > -1) {
        isEmployee = true;
        roles++;
    }
    if (user.roles.indexOf('employer') > -1) {
        isEmployer = true;
        roles++;
    }
    if (user.roles.indexOf('internal') > -1) {
        isInternal = true;
        showNewNavMenu = true;
        roles++;
    }
    if (user.accessAllCustomers || (user.customers && user.customers.length > 1)) {
        isMultiCustomer = true;
        roles++;
    }
    if (roles <= 1)
        return undefined;
    const eeDashboardTitle = showNewNavMenu
        ? `${customEmployeeText} Dashboard - Legacy`
        : `${customEmployeeText} Dashboard`;
    const eeNewNavTitle = `${customEmployeeText} Dashboard - New`;
    const items = [];
    if (isEmployee || isInternal) {
        items.push({
            as: 'link',
            linkType: 'local',
            icon: React.createElement(PersonIcon),
            title: eeDashboardTitle,
            url: '/employee/home',
            onClick: () => {
                trackPageEvent('Experience', Experience.EMPLOYEE);
                setExperience(Experience.EMPLOYEE);
                setIsNewNav(false);
            },
        });
    }
    if (showNewNavMenu) {
        items.push({
            as: 'link',
            linkType: 'local',
            icon: React.createElement(PersonIcon),
            title: eeNewNavTitle,
            url: '/employee/home',
            onClick: () => {
                trackPageEvent('Experience', Experience.EMPLOYEE);
                setExperience(Experience.EMPLOYEE);
                setIsNewNav(true);
            },
        });
    }
    if (isEmployer || isInternal) {
        items.push({
            as: 'link',
            linkType: 'local',
            icon: React.createElement(EmployerResourcesIcon),
            title: 'Employer Dashboard',
            url: '/employer/home',
            onClick: () => {
                trackPageEvent('Experience', Experience.EMPLOYER);
                setExperience(Experience.EMPLOYER);
                changeLanguage(Language.ENGLISH);
                setIsNewNav(false);
            },
        });
    }
    if (isInternal) {
        // Old ExperienceMenu opened Admin Home in the same tab. honest-ui's Link
        // defaults external links to target='_blank'; pass '_self' to override.
        items.push({
            as: 'link',
            linkType: 'external',
            target: '_self',
            icon: React.createElement(ManageAccountIcon),
            title: 'Admin Home',
            url: adminHomeUrl,
        });
    }
    if (isMultiCustomer) {
        items.push({
            as: 'link',
            linkType: 'local',
            icon: React.createElement(KeyboardReturnIcon),
            title: 'Change Customer',
            url: '/customer-search',
            onClick: () => {
                trackPageEvent('Experience', Experience.EMPLOYER);
                setExperience(Experience.EMPLOYER);
                changeLanguage(Language.ENGLISH);
                setIsNewNav(false);
            },
        });
    }
    return items;
};
export default buildExperienceMenuItems;
